import { render, staticRenderFns } from "./BatchesEdit.vue?vue&type=template&id=dc13dcd0&scoped=true"
import script from "./BatchesEdit.vue?vue&type=script&lang=js"
export * from "./BatchesEdit.vue?vue&type=script&lang=js"
import style0 from "./BatchesEdit.vue?vue&type=style&index=0&id=dc13dcd0&prod&scoped=true&lang=css"
import style1 from "./BatchesEdit.vue?vue&type=style&index=1&id=dc13dcd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc13dcd0",
  null
  
)

export default component.exports